import cf from '@/config'
import fc from '@/util/interface'
import st from '@/util/cookies'

const prefix  = cf.prefix;
const api     = fc.biz4;
const expire  = {expires : 1, secure:false};

export default {    
    login(user, pass) {
        return api.post('/user/login', {
            username: user,
            password: pass
        })
    },
    
    set(data) { 
        this.unset();
        
        st.set(prefix+'cid' , data.cid, expire);
        st.set(prefix+'key' , data.token, expire);
        st.set(prefix+'user' , data.user, expire);
        st.set(prefix+'regdate', Number(new Date()), expire);
        st.set(prefix+'granted', "true" + data.token, expire);
        return true;
    },
    
    unset() {        
        st.remove(prefix+'cid');
        st.remove(prefix+'key');
        st.remove(prefix+'user');
        st.remove(prefix+'regdate');
        st.remove(prefix+'granted');
        return true;
    },
    
    isLogin(){
        var reg = this.info();
        if(reg.granted == "true" + reg.token){                                      
            return true;
        } 
        window.getApp.$emit('APP_LOGOUT');  
        return false;
    },
    
    info() {
        return {
            cid     : st.get(prefix+'cid'),
            token   : st.get(prefix+'key'),
            user    : JSON.parse(st.get(prefix+'user')),
            regdate : st.get(prefix+'regdate'),
            granted : st.get(prefix+'granted')            
        }
    },
    
    roles(){
       return this.attributes() ? this.attributes().roles : [];      
    },

    attributes(){
        return this.info().user;        
    },
    
    inArray(needle, haystack = []) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(typeof haystack[i] == 'object') {
                if(arrayCompare(haystack[i], needle)) return true;
            } else {
                if(haystack[i] == needle) return true;
            }
        }
        return false;
    }
    //commit this
}
